// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-imageTemplates3D-Generate3DImagesDialog-module-label {
    -ms-flex-align: start;
        align-items: flex-start;
}

    .csi-middleware-imageTemplates3D-Generate3DImagesDialog-module-label span {
        font-weight: 600;
    }`, "",{"version":3,"sources":["webpack://./src/csi/middleware/imageTemplates3D/Generate3DImagesDialog.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAuB;QAAvB,uBAAuB;AAK3B;;IAHI;QACI,gBAAgB;IACpB","sourcesContent":[".label {\n    align-items: flex-start;\n\n    span {\n        font-weight: 600;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `csi-middleware-imageTemplates3D-Generate3DImagesDialog-module-label`
};
module.exports = ___CSS_LOADER_EXPORT___;
